import Icon from '../components/Icon.vue'

Icon.register({
  pray: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M256 128c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM225.4 297.8l-24.2-28.8-34.8 64.9 109.9 109.9c25.5 25.5 5.8 68.3-28.3 68.3h-208c-22.1 0-40-17.9-40-40s17.9-40 40-40h91.6l-44.8-34.9c-42.9-27.4-57.6-80.1-34.2-123.8l49.4-92c11.1-20.7 32.2-34.4 56.4-36.9 24.8-2.6 48.6 6.9 64 25.3l38.9 46.3 57.4-47c17.1-14 42.3-11.5 56.3 5.6 14 17.1 11.5 42.3-5.6 56.3l-88 72c-17 13.9-41.9 11.5-56-5.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pray.js
// module id = 1659
// module chunks = 0